import * as types from '@/store/mutation-types';
import api from './api';
import moment from 'moment';
import logger from '@/logger';

export const logAction = function ({ commit, state }, { project, object, reason, update }) {
  let textReason = reason;
  var log = {
    type: 'Log',
    user: state.user.username,
    reason: reason,
    timestamp: moment().toISOString(),
  };

  if (object) {
    log.object = {
      title: object.title,
      id: object._id,
      type: object.type,
      rev: object._rev,
    };

    if (update) {
      log.update = update;

      for (var property in update) {
        log.object[property] = object[property];
        textReason += `, ${property}`;
      }
    }
  } else {
    log.object = {};
  }
  if (
    project &&
    (log.object.type !== 'Project' || (state.currentProject && state.currentProject._id === project._id))
  ) {
    log.projectId = project._id;
    logger.debug('logActions::logAction Logging to project', [log]);
    api.logProjectAction(log).catch((e) => {
      logger.error('Database Error occurred while logging project change', e);
      commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
    });
  } else if (!project || log.object.type === 'Project') {
    logger.debug('logActions::logAction Logging to Organisation', [log]);
    api.logOrganisationAction(log).catch((e) => {
      logger.error('Database Error occurred while logging organisation change', e);
      commit(types.setSyncStatus, { status: 'Error', live: 0, message: 'Database Error occurred', count: 1 });
    });
  }
  return textReason;
};



// WEBPACK FOOTER //
// ./src/store/logActions.js